import { Button, Input, Modal } from 'antd';

interface DalantInvalidateModalProps {
  open: boolean;
  selectedCount: number;
  reason: string;
  isPending?: boolean;
  onChangeReason: (value: string) => void;
  onClose: () => void;
  onSubmit: () => void;
}

/**
 * 개편 LMS (교사) - 달란트 관리 페이지 > 반별 학생 달란트 > 달란트 무효화 모달
 */
const DalantInvalidateModal = ({
  open,
  selectedCount,
  reason,
  isPending = false,
  onChangeReason,
  onClose,
  onSubmit,
}: DalantInvalidateModalProps) => {
  return (
    <Modal
      title="달란트 무효화"
      open={open}
      onCancel={onClose}
      footer={null}
      width={420}
    >
      <div className="flex flex-col gap-4">
        <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">
          선택한 학생 {selectedCount}명의 달란트를 무효화합니다.
        </div>

        <Input.TextArea
          rows={3}
          maxLength={100}
          showCount
          placeholder="무효화 사유를 입력해주세요."
          value={reason}
          onChange={(event) => onChangeReason(event.target.value)}
        />

        <div className="mt-3 flex justify-end gap-2">
          <Button onClick={onClose}>취소</Button>

          <Button
            danger
            type="primary"
            loading={isPending}
            disabled={!reason.trim()}
            onClick={onSubmit}
          >
            무효화
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DalantInvalidateModal;
